import styled from 'styled-components';

import {
  createHeightAnimation,
  getHeaderAnimation,
} from '~/modules/asset-overview-header/utils';

export const ThemeHeaderRoot = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--border-default);
  box-shadow: var(--elevation-strong);
`;

const shrinkAnimation = createHeightAnimation(121, 93);
const expandAnimation = createHeightAnimation(93, 121);

export const InnerContainer = styled.div<{ $isCondensed: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  max-width: 1280px;
  padding: 20px 20px 0px 20px;

  [data-tab-header] {
    border-bottom: none;
  }

  ${({ $isCondensed }) =>
    getHeaderAnimation({
      isCondensed: $isCondensed,
      shrinkAnimation,
      expandAnimation,
    })}
`;
